export const oldAppUrlGenerate = (url: string, destination = true, location = '') => {
  const base_url = process.env.REACT_APP_APPLICATION_BASE_URL

  const dest = destination ? '?destination=new-calendar' : ''
  const loc = (destination && !!location.length) ? location : ''

  return base_url + url + dest + loc
}
